/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { css } from "@emotion/react";
import useTheme from "../../../commons/hooks/use-theme";

export type SkeletonProps = {
  width?: number | string;
  height?: number | string;
  circle?: boolean;
  className?: string;
  align?: boolean;
};

const Skeleton: FC<SkeletonProps> = ({ width, height = "1.5em", circle = false, align = true, className }) => {
  const theme = useTheme();

  let borderRadius;
  let alignItem;
  if (circle) {
    borderRadius = "50%";
  } else {
    borderRadius = "4px";
  }
  if (align) {
    alignItem = "0 auto";
  } else {
    alignItem = 0;
  }
  const styles = css`
    display: block;
    position: relative;
    overflow: hidden;
    border-radius: ${borderRadius};
    background-color: ${theme.skeletonBg};
    animation: pulse 1.5s ease-in-out 0.5s infinite;
    margin: ${alignItem};
    margin-bottom: 10px;
    @keyframes pulse {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0.4;
      }
      100% {
        opacity: 1;
      }
    }
  `;

  return <span css={styles} style={{ width: width, height: height }} className={className} />;
};

export default Skeleton;
